import React, { useState } from 'react'
import { useEffect } from 'react'
import {
    useReactTable,
    getCoreRowModel,
    flexRender,
    getPaginationRowModel,
    getSortedRowModel,
    getFilteredRowModel
} from '@tanstack/react-table'
import { useMemo } from 'react'
import "../css/petAdopterTable.css"
import { Link } from 'react-router-dom'


function PetAdopterTable() {

    const [user, setUser] = useState([]);


    const fetchData = async () => {
          try {
            const response = await fetch(`https://petme.onrender.com/user/adopterInfo?submit=true`); 
            const data = await response.json();
            setUser(data);
          } catch (error) {
            console.error(error);
          }
        };
  
    useEffect(() => {
      fetchData();
    }, []);
    const data = useMemo(() => user.map((item, index) => ({ ...item, serial_no: index + 1 })), [user]);  

    /** @type import('@tanstack/react-table').columnDef<any> */
    const columns = [

        {
            header: 'Serial No.',
            accessorKey: 'serial_no',
        },

        {
            header: 'ID',
            accessorKey: '_id',
        },


        {
            header: 'First Name',
            accessorKey: 'firstname',
        },

        {
            header: 'Last Name',
            accessorKey: 'name',
        },

        {
            header: 'Email',
            accessorKey: 'email',
        },


        {
            header: 'Date Of Application',
            accessorKey: 'date',
        },

        // {
        //     header: 'Questionnaire',
        //     accessorKey: 'questionnaire',
        // },

        // {
        //     header: 'Home Visit',
        //     accessorKey: 'home_visit',
        // },

        {
            header: 'Action',
            accessorKey: 'email',
            cell: (value) => (
                <Link to={`/petAdopterCard/${value.cell.row.original.email}`}>
                    <button className="adopterTable-viewBtn">View</button>
                </Link>
            ),
        }
    ]

    const [sorting, setSorting] = useState([])
    const [filtering, setFiltering] = useState('')

    const table = useReactTable({
        data,
        columns,
        getCoreRowModel: getCoreRowModel(),
        //Show Limited Rows
        getPaginationRowModel: getPaginationRowModel(),
        // sort rows
        getSortedRowModel: getSortedRowModel(),
        // Filter Row--- Search in whole Table
        getFilteredRowModel: getFilteredRowModel(),
        state: {
            sorting: sorting,
            globalFilter: filtering
        },
        onSortingChange: setSorting,
        onGlobalFilterChange: setFiltering
    })

    return (

        <div className="w3-container">

            <h2 className="adopterTable-heading">Pet Adopter Table</ h2>
                   
            {/* Search Bar */}

            <input
                className="adopterTable-filterInput"
                type="text"
                placeholder='search here'
                value={filtering}
                onChange={(e) => setFiltering(e.target.value)}

            />

            <table className="w3-table-all">
                <thead>
                    {/* might have more than one haederGroup therefore, using getHeaderGroups */}
                    {table.getHeaderGroups().map(headerGroup => (
                        <tr key={headerGroup.id}>
                            {headerGroup.headers.map(header => (
                                <th key={header.id} onClick={header.column.getToggleSortingHandler()}>
                                    {flexRender(
                                        header.column.columnDef.header,
                                        header.getContext()
                                    )}
                                    {
                                        { asc: <i class="adopterTable-sortingArrow fa-solid fa-caret-up"></i>, desc: <i class="adopterTable-sortingArrow fa-solid fa-caret-down"></i> }[
                                        header.column.getIsSorted() ?? null
                                        ]
                                    }
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>

                <tbody>
                    {table.getRowModel().rows.map(row => (
                        <tr key={row.id}>
                            {row.getVisibleCells().map(cell => (
                                <td>
                                    {flexRender(cell.column.columnDef.cell,
                                        cell.getContext())}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>

                {/* <tfoot></tfoot> */}

            </table>

            <div className="adopterTable-btnDiv">
                <button className="adopterTable-btns" onClick={() => table.setPageIndex(0)}>First Page</button>
                <button className="adopterTable-btns" disabled={!table.getCanPreviousPage()} onClick={() => table.previousPage()}>Previous</button>
                <button className="adopterTable-btns" disabled={!table.getCanNextPage()} onClick={() => table.nextPage()}>Next</button>
                <button className="adopterTable-btns" onClick={() => table.setPageIndex(table.getPageCount() - 1)}>Last Page</button>
            </div>

        </div>

    );
}


export default PetAdopterTable